import { createTheme } from "@mui/material";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#0096d1",
    },
    secondary: {
      main: "#e50921",
    },
  },
});
